import { Product } from "../../data/ecommerce/storeCatalog";
import apiHandler from "../apiHandler";

export const getProduct = async (productId: number): Promise<Product> => {
    const product = await apiHandler({
        endpoint: `/products/${productId}`,
        method: 'GET',
    });

    if (!product) {
        throw new Error('No product found');
    }

    return product;
};
